export const TZ = 'America/Argentina/Buenos_Aires';
/** Corte operativo Argentina (15:00). El servidor usa env; el cliente sigue la API. */
export const CUTOFF_HOUR = 15;
export const CUTOFF_MINUTE = 0;

export const VENCIMIENTO_DIAS_VALIDOS = [7, 14, 21] as const;

export function getArgentinaDateYmd(date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(date);
}

function getArgentinaTimeParts(date = new Date()): { hour: number; minute: number } {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ,
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  }).formatToParts(date);
  const pick = (type: string): number =>
    Number(parts.find((p) => p.type === type)?.value ?? 0);
  return { hour: pick('hour'), minute: pick('minute') };
}

/** true si el registro (createdAt) es a las 15:00 AR o después. */
export function isRegisteredAfterCutoff(createdAt: string | null | undefined): boolean {
  const raw = String(createdAt ?? '').trim();
  if (!raw) return false;
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return false;
  const { hour, minute } = getArgentinaTimeParts(d);
  return hour * 60 + minute >= CUTOFF_HOUR * 60 + CUTOFF_MINUTE;
}

export function addDaysYmd(ymd: string, days: number): string {
  const [y, m, d] = ymd.split('-').map(Number);
  const dt = new Date(Date.UTC(y!, m! - 1, d! + days));
  return dt.toISOString().slice(0, 10);
}

function formatArgentinaNow(date = new Date()): string {
  return new Intl.DateTimeFormat('es-AR', {
    timeZone: TZ,
    dateStyle: 'short',
    timeStyle: 'medium',
  }).format(date);
}

export function getEmissionSchedule(date = new Date()) {
  const today = getArgentinaDateYmd(date);
  const { hour, minute } = getArgentinaTimeParts(date);
  const nowMinutes = hour * 60 + minute;
  const cutoffMinutes = CUTOFF_HOUR * 60 + CUTOFF_MINUTE;
  const beforeCutoff = nowMinutes < cutoffMinutes;
  const fechaEmision = beforeCutoff ? today : addDaysYmd(today, 1);

  return {
    timezone: TZ,
    cutoffHour: CUTOFF_HOUR,
    cutoffMinute: CUTOFF_MINUTE,
    cutoffLabel: `${String(CUTOFF_HOUR).padStart(2, '0')}:${String(CUTOFF_MINUTE).padStart(2, '0')}`,
    todayArgentina: today,
    nowArgentina: formatArgentinaNow(date),
    beforeCutoff,
    fechaEmision,
    message: beforeCutoff
      ? `Pedidos hasta las ${String(CUTOFF_HOUR).padStart(2, '0')}:${String(CUTOFF_MINUTE).padStart(2, '0')} (Argentina) se emiten con fecha de hoy.`
      : `Pasadas las ${String(CUTOFF_HOUR).padStart(2, '0')}:${String(CUTOFF_MINUTE).padStart(2, '0')} (Argentina), la fecha de emisión es el día siguiente.`,
  };
}

export function computeFechaVencimiento(
  fechaEmision: string | null | undefined,
  precioTipo: string,
  vencimientoDias: number | null | undefined
): string | null {
  const fecha = String(fechaEmision ?? '').trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha)) return null;
  if (precioTipo === 'mercado') return fecha;
  if (precioTipo === 'base') {
    const dias = Number(vencimientoDias);
    if (!VENCIMIENTO_DIAS_VALIDOS.includes(dias as (typeof VENCIMIENTO_DIAS_VALIDOS)[number])) {
      return null;
    }
    return addDaysYmd(fecha, dias);
  }
  return null;
}
